
























































































































































import Vue from "vue";
import store, { AccItemParamStore } from "../services/AccItemParamStore";
import Page from "../../../components/Page.vue";
import AccItemParamRow from "../models/AccItemParamRow";
import setAttribute from "../../../utils/dom";
import IconButton from "@/components/IconButton.vue";
import { t } from "@/plugins/i18n";


interface Data {
  store: AccItemParamStore;
}

export default Vue.extend<Data, {}, {}, {}>({
  components: {
    Page,
    IconButton,
  },

  data(): Data {
    return {
      store,
    };
  },

  async beforeMount() {
    await this.store.load();
  },

  computed: {
    columns() {
      return [
        { cell: "commandTemplate", width: "95px" },
        { field: "brandName", title: t("Gyartmany"), cell: "brandTemplate" },
        { field: "depotName", title: t("Telephely"), cell: "depotTemplate" },
        { field: "statGroupName", title: t("AccItemParam_CikkStatisztikaiCsoport"), cell: "statGroupTemplate" },
        { field: "divItemName", title: t("Aldivizio"), cell: "divItemTemplate" },
        ...this.store.paramTypes.map((type) => ({
          field: `pt${type.id}`,
          title: type.name,
          cell: "valueTemplate",
        })),
        { width: 0 },
      ];
    },

    items() {
      return this.store.rows;
    },

    hasEditing() {
      return this.store.rows.some((r: AccItemParamRow) => r.inEdit);
    },
  },

  methods: {
    addRow() {
      this.store.addRow();
    },

    editRow(row: AccItemParamRow) {
      this.store.setEditing(row);
    },

    saveRow(row: AccItemParamRow) {
      this.store.saveRow(row);
    },

    cancelEdit(row: AccItemParamRow) {
      this.store.cancelEdit(row);
    },

    deleteRow(row: AccItemParamRow) {
      this.store.setDeleting(row);
    },

    confirmDelete(row: AccItemParamRow) {
      row.deleting = false;
      this.store.deleteRow(row);
    },

    cancelDelete(row: AccItemParamRow) {
      row.deleting = false;
    },
  },
});
